'use client';

import { cn } from '@core/utils';

import { AD_PLACEMENTS } from './adPlacements';
import { BannerAdSlot } from './BannerAdSlot';

interface GlobalDesktopSideAdBannerProps {
  className?: string;
  footer?: React.ReactNode;
}

//* 전역 PC 화면의 공용 우측 광고. 광고 유무와 무관하게 300 칼럼을 예약한다 (footer도 표시).
export const GlobalDesktopSideAdBanner = ({
  className,
  footer,
}: GlobalDesktopSideAdBannerProps) => (
  <aside
    className={cn('hidden w-300 shrink-0 flex-col gap-16 xl:flex', className)}
  >
    <BannerAdSlot {...AD_PLACEMENTS.globalSide} />
    {footer}
  </aside>
);
